import React, { useEffect } from "react";
import {
  Grid,
  TextField,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_ALL_EXAM_PAPERS } from "utils/graphql/services/ai-evaluation/queries";
import autoGradeClient from "utils/graphql/autoGradeClient";

function ExamPaperInfo({
  examPaperId,
  onChange,
}: {
  examPaperId: any;
  onChange: (field: string, value: any) => void;
}) {
  const { data, loading, error } = useQuery(GET_ALL_EXAM_PAPERS, {
    client: autoGradeClient,
    variables: { input: { id: parseInt(examPaperId) } },
    skip: !examPaperId,
  });

  const examPaper = data?.getExamPapers?.examPapers?.[0];

  useEffect(() => {
    if (examPaper) {
      onChange("title", examPaper.title);
      onChange("totalSections", examPaper.totalSections);
      onChange("totalMarks", examPaper.totalMarks);
      onChange("totalQuestions", examPaper.totalQuestions);
      onChange("questionTypes", examPaper.questionTypes || []);
    }
  }, [examPaper]);

  if (loading) return <CircularProgress />;
  if (error) return <div>Error loading exam paper</div>;
  if (!examPaper) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ mb: 2, color: "primary.main", fontWeight: "bold" }}
      >
        Exam Paper Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Title"
            size="small"
            fullWidth
            value={examPaper.title || ""}
            disabled
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#666",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Total Sections"
            type="number"
            size="small"
            fullWidth
            value={examPaper.totalSections || ""}
            disabled
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#666",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Total Marks"
            type="number"
            size="small"
            fullWidth
            value={examPaper.totalMarks || ""}
            disabled
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#666",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Total Questions"
            type="number"
            size="small"
            fullWidth
            value={examPaper.totalQuestions || ""}
            disabled
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#666",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Question Types (comma separated)"
            size="small"
            fullWidth
            value={examPaper.questionTypes?.join(", ") || ""}
            disabled
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#666",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ExamPaperInfo;
